import { render } from "./Day.vue?vue&type=template&id=2d9732ba&scoped=true&ts=true"
import script from "./Day.vue?vue&type=script&lang=ts"
export * from "./Day.vue?vue&type=script&lang=ts"

import "./Day.vue?vue&type=style&index=0&id=2d9732ba&scoped=true&lang=less"

import exportComponent from "D:\\work\\project\\mobile-mpe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9732ba"]])

export default __exports__